import React from 'react';

export const BuscadorContactos = (props) => {
	const {FiltroMessage, setFiltroMessage} = props;

	const onInputChange = ({target}) => {
		setFiltroMessage(target.value);
	};

	return (
		<div className='BuscadorMensajes'>
			<div className='centrador'>
				<input
					type='text'
					placeholder='User'
					name='username'
					value={FiltroMessage}
					onChange={onInputChange}
				/>
			</div>
		</div>
	);
};
